module.exports = __webpack_public_path__ + "img/EXV_Weinflaschen_Icons_Rotweine.3035b66b.svg";